import React from 'react';
import styled from 'styled-components';
import Lottie from 'lottie-react';

const LoadingBox = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 100;
    backdrop-filter: blur(4px);

    background-color: rgba(44, 44, 44, 0.2);
`;

const LottieWrapper = styled.div`
    width: 150px;
    height: 150px;

    @media screen and (max-width: 768px) {
        width: 120px;
        height: 120px;
    }

    @media screen and (max-width: 480px) {
        width: 100px;
        height: 100px;
    }
`;

const LottieLoading = ({loadingAnimation}) => {
    return (
        <LoadingBox>
            <LottieWrapper>
                <Lottie
                    animationData={loadingAnimation}
                    loop={true}
                    autoplay={true}
                />
            </LottieWrapper>
        </LoadingBox>
    );
};

export default LottieLoading;
